var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"bidule-panel bidule-panel-sponsor-link\"\u003E\u003Cdiv class=\"text-center\"\u003E\u003Ch4\u003ELIENS DE&nbsp;PARRAINAGE\u003C\u002Fh4\u003E\u003Cp ng-bind=\"displayedSponsorUrl\"\u003E\u003C\u002Fp\u003E\u003Cbutton class=\"btn background-waterblue\" clipboard text=\"sponsorUrl\" uib-popover=\"Le lien a été copié dans le presse-papier\" popover-placement=\"bottom\" popover-trigger=\"'outsideClick'\" popover-class=\"popover-sponsor\" type=\"button\"\u003Ecopier\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/states/personalInformation/component/personalInfoSponsorLink.jade
// module id = 1012
// module chunks = 1